export interface PampAssessmentTodoTemplate {
  id: string;
  title: string;
  titleLower?: string;
  ownerId?: string;
  createdAt?: string;
  updatedAt?: string;
  name?: string;
}

/** A PAMP questionnaire template with its repeat schedule, as returned by /pampQRERecurrence. */
export interface PampQuestionnaireRecurrence {
  id: string;
  repeatInfo?: {
    duration?: string;
  };
  todoInfo?: {
    content?: {
      questionnaireType?: string;
      title?: string;
    };
  };
}

/** PAMP list endpoints return either a bare array or `{ data: [...] }`. */
export type PampListResponse<T> = T[] | { data?: T[] };

export function pampListFromResponse<T>(response: PampListResponse<T>): T[] {
  if (Array.isArray(response)) {
    return response;
  }
  if (response && response.data) {
    return response.data;
  }
  return [];
}

export function pampAssessmentTodoTemplatesFromResponse(
  todoTemplates: PampListResponse<PampAssessmentTodoTemplate>
): PampAssessmentTodoTemplate[] {
  return pampListFromResponse(todoTemplates);
}
